export default "\n{% block sw_rule_modal_basic_info_description %}\n{% endblock %}\n\n";